import { tireOrderingTestInstance } from '../axios';

const getPlantsWithInventoryList = (pagination: any, sortOrder: any, filters: any) => 
  tireOrderingTestInstance.post('/plant/check-inventory', {pagination, sortOrder, filters});

export default {
  getPlantsWithInventoryList,
};
